import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import TitlesProps from "./Props/TitlesProps";
import { ClientFeedbackTitle } from "../data";

interface Comment {
  id: string;
  name: string;
  text: string;
  createdAt: Date;
}

const Comments: React.FC = () => {
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [comments, setComments] = useState<Comment[]>([]);

  useEffect(() => {
    const q = query(collection(db, "comments"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as Comment[];
      setComments(data);
    });
    return () => unsubscribe();
  }, []);

  const addComment = async () => {
    if (!name.trim() || !text.trim()) return;
    await addDoc(collection(db, "comments"), {
      name,
      text,
      createdAt: new Date(),
    });
    setName("");
    setText("");
  };

  return (
    <section className="comments">
      <TitlesProps data={ClientFeedbackTitle} />
      <section className="comments-container ">
        <ul className="clients-comments">
          {comments.map((c) => (
            <li key={c.id}>
              <article>
                <blockquote>
                  <strong>{c.name}</strong>
                  <p>{c.text}</p>
                </blockquote>
              </article>
            </li>
          ))}
        </ul>

        <section className="comments-input-area">
          <h3>Sua opinião faz a diferença! Deixe aqui seu comentário:</h3>

          <input
            placeholder="Seu nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <textarea
            placeholder="Seu comentário"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <button onClick={addComment}>Adicione seu comentário</button>
        </section>
      </section>
    </section>
  );
};

export default Comments;
